import { Routes, Route } from 'react-router';

import Index from './index';
import MyTimes from './myTimes/myTimes';

const Account = () => {
	return (
		<div className="pageContainer">
			<Routes>
				<Route index element={<Index />} />
				<Route path="myTimes" element={<MyTimes />} />
			</Routes>
		</div>
	);
};

export default Account;
